// extracted by mini-css-extract-plugin
export default {"card":"Card_card__FC6oY","padding":"Card_padding__KjyQ7","text":"Card_text__+ATSb","position":"Card_position__BWoh2","photo":"Card_photo__QDMXy"};